<template>
	<div class="vr">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="vrbox">
			<div>
				<a :href="$api.vrRightUrl" target="_blank"><img src="../assets/images/vrright.png" /></a>
			</div>
			<div>
				<a :href="$api.vrLeftUrl" target="_blank"><img src="../assets/images/vrleft.png"/></a>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	
	export default {
		components: {
			back
		},
		data() {
			return {
			}
		},
		created() {
			
		},
		methods: {
			
		},
		mounted() {

		}
	}
</script>

<style scoped>
	.vr {
		background: url(../assets/images/vrbag.jpg) no-repeat;
		background-size: 100% 100%;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}

	.vr .vrbox {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 8rem;
		right: 1rem;
		bottom: 1rem;
		text-align: center;
	}

	.vr .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}
	.vr .vrbox{
		display: flex;
	}
	.vr .vrbox div{
		flex: 1;
		width: 50%;
		position: relative;
	}
	.vr .vrbox div img,.vr .vrbox div a{
		display: block;
		position: absolute;
		margin: auto;
		top: 0;
		bottom: 0;
		width: 40rem;
	}
	.vr .vrbox div a{
		width: 40rem;
		height: 40rem;
	}
	.vr .vrbox div:first-child a{
		right: 2rem;
	}
	.vr .vrbox div:last-child a{
		left: 2rem;
	}
	
</style>
